import React, { useEffect, useState } from "react"
import Layout from "../components/layout"
import MaintenanceTitle from "../components/_titles/_maintenance_title"
import maintenanceStyles from "../styles/pages/maintenance/_maintenance.module.scss"
import QuestionButton from "../components/_maintenance/question_button"
import QuestionInput from "../components/_maintenance/question_input"
import QuestionDate from "../components/_maintenance/question_date"
import { ButtonSemicircle } from "../components/buttons/_button_semicircle"
import { useCurrenDeviceMaintenance } from "../hooks/useCurrentDeviceMaintenance"
import useForm from "../hooks/useForm"
import { usePrismVersions } from "../hooks/use_prism-versions"
import { isNullOrUndefined } from "util"
import validate from "../components/_maintenance/maintenanceFormValidationRules"
import { navigate } from "gatsby"
import underlinedStyle from "../styles/_components/_maintenance/_input_underlined.module.scss"
import { ButtonArrow } from "../components/buttons/_btn_arrow"
import { TYPES, POSITION } from "../components/buttons/_btn_arrow"
import axios from 'axios'
import { usePrismModels } from "../hooks/use_prism-models"
import { usePrismCategories } from "../hooks/use_prims_categories"
import { pushToDataLayer } from "../components/gtm/pushDataLayer"


const Maintenance = () => {

  const API_PATH = process.env.GATSBY_CALOREX_MAINTENANCE_ENDPOINT
  const data = usePrismVersions().nodes
  const models = usePrismModels().nodes
  const categories = usePrismCategories().nodes
  const [versions, setVersions] = useState(null)

  const [disabled, setDisabled] = useState(false)

  const steps = {
    0: "Para llenar el formulario necesitarás algunos datos:",
    1: "Paso 1 de 2",
    2: "Paso 2 de 2",
  }

  const services = [
    {
      uid: 1,
      value: "INSTALACIÓN / MANTENIMIENTO",
    },
    {
      uid: 2,
      value: "REGISTRO DE GARANTÍA",
    },
    {
      uid: 3,
      value: "REPORTE DE FALLA",
    },
    {
      uid: 4,
      value: "ASESORÍA TÉCNICA",
    },
    // {
    //   uid: 5,
    //   value: "SOLICITUD DE CAPACITACIÓN",
    // },
    // {
    //   uid: 6,
    //   value: "QUIERO SER TÉCNICO / DISTRIBUIDOR",
    // },
    // {
    //   uid: 7,
    //   value: "SUGERENCIAS",
    // },
  ]

  const tiposEnergia = [
    {
      uid: 1,
      value: "GAS LP",
    },
    {
      uid: 2,
      value: "GAS NATURAL",
    },
    {
      uid: 3,
      value: "ELECTRICO",
    },
    {
      uid: 4,
      value: "SOLAR",
    },
  ]

  const myInputs = {
    servicio: services[0],
    modelo: {
      uid: data[0].uid,
      value: data[0].data.title.text,
    },
    numero_serie: "",
    tipo_energia: tiposEnergia[0],
    tienda_compra: "",
    fecha_compra: "",
    numero_ticket: "",
    fecha_expira: "",
    mensaje: "",
    nombre: "",
    apellidos: "",
    calle: "",
    num_ext: "",
    num_int: "",
    colonia: "",
    ciudad: "",
    estado: "",
    codigo_postal: "",
    email: "",
    phone: "",
    marca: "Calorex",
  }

  const fillViewInputs = () => {
    for (let key in inputs) {
      const element = document.getElementById(key)
      if (!isNullOrUndefined(element)) {
        element.value = inputs[key]
      }
    }
  }

  const [device] = useCurrenDeviceMaintenance(fillViewInputs)
  const { inputs, handleInputChange, handleSubmit, errors, handleNextStep, step, handleBackStep, isFaultReport } = useForm(formValidCallback, myInputs, validate)

  const fillVersions = () => {
    // console.log('entro a fillVersion')
    let orderModels = []
    categories.map(category => {
      models
        .filter(model => model.data.category.uid === category.uid)
        .map(model => {
          const versions_array = data.filter(version => version.data.model.document[0].data.model_name.text === model.data.model_name.text)
          // console.log('versions_array',versions_array);
          versions_array.sort(function (a, b) {
            return a.data.sort_index - b.data.sort_index
          })
          return orderModels = [
            ...orderModels,
            {
              name: model.data.model_name.text,
              versions: versions_array,
            },
          ]
        })
      return null
    })
    setVersions(orderModels)
  }

  useEffect(() => {
    //clases extra para mantenimiento
    document.getElementsByClassName("stage")[0].classList.add("stage__maintenance")
    document.getElementsByClassName("main")[0].classList.add("main__maintenance")
    document.querySelector("footer").style.display = "none"

    //call function to fill versions
    fillVersions()

    return () => {
      document.querySelector("footer").style.display = "block"
      document.getElementsByClassName("stage")[0].classList.remove("stage__maintenance")
      document.getElementsByClassName("main")[0].classList.remove("main__maintenance")
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    //regresa el scroll al principio al cambiar de paso
    window.scrollTo(0, 0)
    //Método que llena los inputs previamente llenos
    fillViewInputs()
    setStepClass()
    // eslint-disable-next-line
  }, [step])

  function setStepClass() {
    if (step == null) return
    const stage = document.getElementsByClassName("stage")[0]
    const maintenanceContainer = document.getElementsByClassName(maintenanceStyles.maintenance__container)[0]
    switch (step) {
      case 0:
        if (stage !== null && stage !== undefined) {
          stage.classList.remove("stage__maintenance_step1")
        }
        if (maintenanceContainer !== null && maintenanceContainer !== undefined) {
          maintenanceContainer.classList.remove(maintenanceStyles.maintenance__container_step1)
        }
        break
      case 1:
        if (stage !== null && stage !== undefined) {
          stage.classList.add("stage__maintenance_step1")
        }
        if (maintenanceContainer !== null && maintenanceContainer !== undefined) {
          maintenanceContainer.classList.add(maintenanceStyles.maintenance__container_step1)
        }
        break
      case 2:
        break
      default:
        break
    }
  }

  function getStepText(step) {
    if (steps.hasOwnProperty(step)) {
      return steps[step]
    }
  }

  function handlerClickSend() {
    document.getElementById("submit__button").click()
  }

  function formValidCallback() {
    if (disabled || inputs.nombre === "" || inputs.apellidos === "" || inputs.calle === "" || inputs.num_ext === "" || inputs.colonia === "" || inputs.ciudad === "" || inputs.estado === "" || inputs.codigo_postal === "" || inputs.email === "" || inputs.phone === "") return

    setDisabled(true)
    // console.log('es valido el formulario', inputs) 
    axios.post(API_PATH, inputs).then(function (response) {
      console.log(response);
      pushToDataLayer(
        {
          event: "contact_form",
          category_submission: inputs.servicio.value,
        }
      )

      navigate("/enviado")
    })
      .catch(function (error) {
        console.log(error);
      })

  }

  function getQuestions() {
    switch (step) {
      case 0:
        return (
          <>
            <div className={maintenanceStyles.step0__container}>
              <p>Te recomendamos tener a la mano tu ticket de compra, el modelo de tu Calorex y el No. de serie de tu calentador</p>
            </div>
          </>
        )
      case 1:
        switch (device) {
          case "mobile":
            return (
              <>
                <div className={maintenanceStyles.step1__container}>
                  <QuestionButton _classh3="service__question_title" isEnergyDropdown={true} _onChange={handleInputChange} inputs={inputs} name="servicio" dropdownList={services} question="Solicito ayuda para:" required={true} />
                  <QuestionButton isDropdownModels={true} _onChange={handleInputChange} inputs={inputs} name="modelo" dropdownList={versions} question="El modelo de mi calentador es:" required={true} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} question="Con el número de serie:" placeholder="328-X-324-7845-93170C" name="numero_serie" required={true} error={errors.numero_serie} />
                  <QuestionButton isEnergyDropdown={true} _onChange={handleInputChange} inputs={inputs} name="tipo_energia" dropdownList={tiposEnergia} question="Utiliza energía tipo:" required={true} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} question="Lo compré en la tienda:" placeholder="Liverpool" name="tienda_compra" required={true} error={errors.tienda_compra} />
                  <QuestionDate _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} question="El día:" name="fecha_compra" required={true} error={errors.fecha_compra} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} question="Y me asignaron el No. de ticket:" placeholder="2855-9348-3574-5371" name="numero_ticket" required={true} error={errors.numero_ticket} />
                  <QuestionDate _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} question="La garantía vence el:" name="fecha_expira" required={true} error={errors.fecha_expira} />
                  {
                    isFaultReport ?
                      <div className={maintenanceStyles.comments__container}>
                        <label className={maintenanceStyles.comments_label} htmlFor="mensaje">
                          El problema que mi calentador presenta es:
                        </label>
                        <textarea onChange={handleInputChange} className={maintenanceStyles.comments} rows="8" id="mensaje" name="mensaje" placeholder="Mi calentador tarda mucho en..." required />
                        <p className={underlinedStyle.warning__required}>{errors.mensaje ? "*Campo obligatorio" : null}</p>
                      </div>
                      :
                      <div className={maintenanceStyles.comments__container}>
                        <label className={maintenanceStyles.comments_label} htmlFor="mensaje">
                          Y estos son mis comentarios:
                        </label>
                        <textarea onChange={handleInputChange} className={maintenanceStyles.comments} rows="8" id="mensaje" name="mensaje" placeholder="Mis comentarios..." required />
                        <p className={underlinedStyle.warning__required}>{errors.mensaje ? "*Campo obligatorio" : null}</p>
                      </div>
                  }
                </div>
              </>
            )
          case "tablet":
            return (
              <>
                <div className={`${maintenanceStyles.step1__container} ${maintenanceStyles.step1__container_custom}`}>
                  <QuestionButton _onChange={handleInputChange} inputs={inputs} name="servicio" dropdownList={services} question="Solicito ayuda para:" required={true} />
                  <QuestionButton isDropdownModels={true} _onChange={handleInputChange} inputs={inputs} name="modelo" dropdownList={versions} question="El modelo de mi calentador es" required={true} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} question="con el número de serie" placeholder="328-X-324-7845-93170C" name="numero_serie" required={true} error={errors.numero_serie} />
                  <div className={maintenanceStyles.several_questions_grid}>
                    <QuestionButton _onChange={handleInputChange} inputs={inputs} name="tipo_energia" dropdownList={tiposEnergia} question="y energía tipo" required={true} />
                    <QuestionInput question="Lo compré en la tienda" _onChange={handleInputChange} inputs={inputs} placeholder="Liverpool" name="tienda_compra" required={true} error={errors.tienda_compra} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionDate question="el día" _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} name="fecha_compra" required={true} error={errors.fecha_compra} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="y me asignaron el No. de ticket" _onChange={handleInputChange} inputs={inputs} placeholder="2855-9348-3574-5371" name="numero_ticket" required={true} error={errors.numero_ticket} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionDate className={maintenanceStyles.flex__grow} question="La garantía vence el" _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} name="fecha_expira" required={true} error={errors.fecha_expira} />
                    {
                      isFaultReport ?
                        <label className={maintenanceStyles.comments_label} htmlFor="mensaje">
                          El problema que mi calentador presenta es:
                        </label>
                        :
                        <label className={maintenanceStyles.comments_label} htmlFor="mensaje">
                          Y estos son mis comentarios:
                        </label>
                    }
                  </div>
                  <div className={maintenanceStyles.comments__container}>
                    {
                      isFaultReport ?
                        <textarea onChange={handleInputChange} className={maintenanceStyles.comments} rows="3" id="mensaje" name="mensaje" placeholder="Mi calentador tarda mucho en..." required />
                        :
                        <textarea onChange={handleInputChange} className={maintenanceStyles.comments} rows="3" id="mensaje" name="mensaje" placeholder="Mis comentarios..." required />
                    }
                    <p className={underlinedStyle.warning__required}>{errors.mensaje ? "*Campo obligatorio" : null}</p>
                  </div>
                </div>
              </>
            )
          case "desktopMin":
            return (
              <>
                <div className={maintenanceStyles.step1__container}>
                  <QuestionButton _onChange={handleInputChange} inputs={inputs} name="servicio" dropdownList={services} question="Solicito ayuda para" required={true} />
                  <QuestionButton isDropdownModels={true} _onChange={handleInputChange} inputs={inputs} name="modelo" dropdownList={versions} question="El modelo de mi calentador es" required={true} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} question="con el número de serie" placeholder="328-X-324-7845-93170C" name="numero_serie" required={true} error={errors.numero_serie} />
                  <div className={maintenanceStyles.several_questions_grid}>
                    <QuestionButton _onChange={handleInputChange} inputs={inputs} name="tipo_energia" dropdownList={tiposEnergia} question="y energía tipo" required={true} />
                    <QuestionInput question="Lo compré en la tienda" _onChange={handleInputChange} inputs={inputs} placeholder="Liverpool" name="tienda_compra" required={true} error={errors.tienda_compra} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionDate question="el día" _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} name="fecha_compra" required={true} error={errors.fecha_compra} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="y me asignaron el No. de ticket" _onChange={handleInputChange} inputs={inputs} placeholder="2855-9348-3574-5371" name="numero_ticket" required={true} error={errors.numero_ticket} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionDate _classContainer={maintenanceStyles.flex__grow_nopadding} question="La garantía vence el" _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} name="fecha_expira" required={true} error={errors.fecha_expira} />
                    {
                      isFaultReport ?
                        <label className={maintenanceStyles.comments_label} htmlFor="mensaje">
                          El problema que mi calentador presenta es:
                        </label>
                        :
                        <label className={maintenanceStyles.comments_label} htmlFor="mensaje">
                          Y estos son mis comentarios:
                        </label>
                    }
                  </div>
                  {
                    isFaultReport ?
                      <QuestionInput _classInputContainer="question_nomargin" _className="left_text" _onChange={handleInputChange} inputs={inputs} id="mensaje" name="mensaje" placeholder="Mi calentador tarda mucho en encender" required={true} error={errors.mensaje} />
                      :
                      <QuestionInput _classInputContainer="question_nomargin" _className="left_text" _onChange={handleInputChange} inputs={inputs} id="mensaje" name="mensaje" placeholder="Mis comentarios..." required={true} error={errors.mensaje} />
                  }

                </div>
              </>
            )
          case "desktop":
            return (
              <>
                <div className={maintenanceStyles.step1__container}>
                  <div className={`${maintenanceStyles.grid_service_model} ${maintenanceStyles.several_questions_margin_bottom}`}>
                    <QuestionButton _onChange={handleInputChange} inputs={inputs} name="servicio" dropdownList={services} question="Solicito ayuda para" required={true} />
                    <QuestionButton isDropdownModels={true} _onChange={handleInputChange} inputs={inputs} name="modelo" dropdownList={versions} question="El modelo de mi calentador es" required={true} />
                  </div>
                  <div className={maintenanceStyles.several_questions_grid_3}>
                    <QuestionInput _onChange={handleInputChange} inputs={inputs} question="con el número de serie" placeholder="328-X-324-7845-93170C" name="numero_serie" required={true} error={errors.numero_serie} />
                    <QuestionButton _onChange={handleInputChange} inputs={inputs} name="tipo_energia" dropdownList={tiposEnergia} question="y energía tipo" required={true} />
                    <QuestionInput question="Lo compré en la tienda" _onChange={handleInputChange} inputs={inputs} placeholder="Liverpool" name="tienda_compra" required={true} error={errors.tienda_compra} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionDate question="el día" _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} name="fecha_compra" required={true} error={errors.fecha_compra} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="me asignaron el número de ticket" _onChange={handleInputChange} inputs={inputs} placeholder="2855-9348-3574-5371" name="numero_ticket" required={true} error={errors.numero_ticket} />
                    <QuestionDate _classContainer={maintenanceStyles.input__padding} question="La garantía vence el" _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} name="fecha_expira" required={true} error={errors.fecha_expira} />
                  </div>
                  {
                    isFaultReport ?
                      <QuestionInput question="El problema que mi calentador presenta es:" _onChange={handleInputChange} inputs={inputs} id="mensaje" name="mensaje" placeholder="Mi calentador tarda mucho en encender porque..." required={true} error={errors.mensaje} />
                      :
                      <QuestionInput question="Y estos son mis comentarios:" _onChange={handleInputChange} inputs={inputs} id="mensaje" name="mensaje" placeholder="Mis comentarios..." required={true} error={errors.mensaje} />
                  }
                </div>
              </>
            )
          case "xlg":
            return (
              <>
                <div className={maintenanceStyles.step1__container}>
                  <div className={`${maintenanceStyles.grid_service_model} ${maintenanceStyles.several_questions_margin_bottom}`}>
                    <QuestionButton _onChange={handleInputChange} inputs={inputs} name="servicio" dropdownList={services} question="Solicito ayuda para" required={true} />
                    <QuestionButton isDropdownModels={true} _onChange={handleInputChange} inputs={inputs} name="modelo" dropdownList={versions} question="El modelo de mi calentador es" required={true} />
                  </div>
                  <div className={maintenanceStyles.several_questions_grid_3}>
                    <QuestionInput _onChange={handleInputChange} inputs={inputs} question="con el número de serie" placeholder="328-X-324-7845-93170C" name="numero_serie" required={true} error={errors.numero_serie} />
                    <QuestionButton _onChange={handleInputChange} inputs={inputs} name="tipo_energia" dropdownList={tiposEnergia} question="y energía tipo" required={true} />
                    <QuestionInput question="Lo compré en la tienda" _onChange={handleInputChange} inputs={inputs} placeholder="Liverpool" name="tienda_compra" required={true} error={errors.tienda_compra} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionDate question="el día" _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} name="fecha_compra" required={true} error={errors.fecha_compra} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="me asignaron el número de ticket" _onChange={handleInputChange} inputs={inputs} placeholder="2855-9348-3574-5371" name="numero_ticket" required={true} error={errors.numero_ticket} />
                    <QuestionDate _classContainer={maintenanceStyles.input__padding} question="La garantía vence el" _popperPlacement="auto-left" _onChange={handleInputChange} inputs={inputs} name="fecha_expira" required={true} error={errors.fecha_expira} />
                  </div>
                  {
                    isFaultReport ?
                      <QuestionInput question="El problema que mi calentador presenta es:" _onChange={handleInputChange} inputs={inputs} id="mensaje" name="mensaje" placeholder="Mi calentador tarda mucho en encender porque..." required={true} error={errors.mensaje} />
                      :
                      <QuestionInput question="Y estos son mis comentarios:" _onChange={handleInputChange} inputs={inputs} id="mensaje" name="mensaje" placeholder="Mis comentarios..." required={true} error={errors.mensaje} />
                  }
                </div>
              </>
            )
          default:
            return null
        }
      case 2:
        switch (device) {
          case "mobile":
            return (
              <>
                <div className={maintenanceStyles.step1__container}>
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Mi nombre es:" placeholder="Miguel Angel" name="nombre" required={true} error={errors.nombre} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Mis apellidos son:" placeholder="Medina Calvillo" name="apellidos" required={true} error={errors.apellidos} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Vivo en la calle:" placeholder="Miguel Hidalgo" name="calle" required={true} error={errors.calle} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Número exterior:" placeholder="1534" name="num_ext" required={true} error={errors.num_ext} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Número interior:" placeholder="15" name="num_int" error={errors.num_int} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Colonia:" placeholder="Independencia" name="colonia" required={true} error={errors.colonia} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Ciudad:" placeholder="Saltillo" name="ciudad" required={true} error={errors.ciudad} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Estado:" placeholder="Coahuila" name="estado" required={true} error={errors.estado} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Código postal:" placeholder="25000" name="codigo_postal" required={true} error={errors.codigo_postal} />
                  <p className={maintenanceStyles.contact__title}>Para comunicarse conmigo:</p>
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Correo electrónico:" placeholder="miguel_medina@correo.com" name="email" required={true} type="email" error={errors.email} />
                  <QuestionInput _onChange={handleInputChange} inputs={inputs} _className="left_text" question="Número:" placeholder="844 63 87 033" name="phone" required={true} error={errors.phone} maxlength="10" />
                </div>
              </>
            )
          case "tablet":
            return (
              <>
                <div className={maintenanceStyles.step1__container}>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionInput question="Mi nombre es" _onChange={handleInputChange} inputs={inputs} placeholder="Miguel Angel" name="nombre" required={true} error={errors.nombre} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="y apellidos" _onChange={handleInputChange} inputs={inputs} placeholder="Medina Calvillo" name="apellidos" required={true} error={errors.apellidos} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionInput question="Vivo en la calle" _onChange={handleInputChange} inputs={inputs} placeholder="Miguel Hidalgo" name="calle" required={true} error={errors.calle} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="número exterior" _onChange={handleInputChange} inputs={inputs} placeholder="1534" name="num_ext" required={true} error={errors.num_ext} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionInput question="y número interior" _onChange={handleInputChange} inputs={inputs} placeholder="15" name="num_int" error={errors.num_int} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="en la colonia" _onChange={handleInputChange} inputs={inputs} placeholder="Independencia" name="colonia" required={true} error={errors.colonia} />
                  </div>
                  <QuestionInput question="ubicada en la ciudad de" _onChange={handleInputChange} inputs={inputs} placeholder="Saltillo" name="ciudad" required={true} error={errors.ciudad} />
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionInput question="del estado de" _onChange={handleInputChange} inputs={inputs} placeholder="Coahuila" name="estado" required={true} error={errors.estado} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="con codigó postal" _onChange={handleInputChange} inputs={inputs} placeholder="25000" name="codigo_postal" required={true} error={errors.codigo_postal} />
                  </div>
                  <QuestionInput question="Para comunicarse conmigo escribir al correo electrónico:" _onChange={handleInputChange} inputs={inputs} placeholder="miguel_medina@correo.com" name="email" required={true} type="email" error={errors.email} />
                  <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="o llamar al número:" _onChange={handleInputChange} inputs={inputs} placeholder="844 63 87 033" name="phone" required={true} error={errors.phone} maxlength="10" />
                </div>
              </>
            )
          case "desktopMin":
            return (
              <>
                <div className={maintenanceStyles.step1__container}>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionInput question="Mi nombre es" _onChange={handleInputChange} inputs={inputs} placeholder="Miguel Angel" name="nombre" required={true} error={errors.nombre} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="y apellidos" _onChange={handleInputChange} inputs={inputs} placeholder="Medina Calvillo" name="apellidos" required={true} error={errors.apellidos} />
                  </div>
                  <div className={maintenanceStyles.several_questions_grid}>
                    <QuestionInput question="Vivo en la calle" _onChange={handleInputChange} inputs={inputs} placeholder="Miguel Hidalgo" name="calle" required={true} error={errors.calle} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="número exterior" _onChange={handleInputChange} inputs={inputs} placeholder="1534" name="num_ext" required={true} error={errors.num_ext} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionInput question="y número interior" _onChange={handleInputChange} inputs={inputs} placeholder="15" name="num_int" error={errors.num_int} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="en la colonia" _onChange={handleInputChange} inputs={inputs} placeholder="Independencia" name="colonia" required={true} error={errors.colonia} />
                  </div>
                  <QuestionInput question="ubicada en la ciudad de" _onChange={handleInputChange} inputs={inputs} placeholder="Saltillo" name="ciudad" required={true} error={errors.ciudad} />
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionInput question="del estado de" _onChange={handleInputChange} inputs={inputs} placeholder="Coahuila" name="estado" required={true} error={errors.estado} />
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow} question="con código postal" _onChange={handleInputChange} inputs={inputs} placeholder="25000" name="codigo_postal" required={true} error={errors.codigo_postal} />
                  </div>
                  <QuestionInput question="Para comunicarse conmigo escribir al correo electrónico:" _onChange={handleInputChange} inputs={inputs} placeholder="miguel_medina@correo.com" name="email" required={true} type="email" error={errors.email} />
                  <QuestionInput question="o llamar el número:" _onChange={handleInputChange} inputs={inputs} placeholder="844 63 87 033" name="phone" required={true} error={errors.phone} maxlength="10" />
                </div>
              </>
            )
          case "desktop":
            return (
              <>
                <div className={maintenanceStyles.step1__container}>
                  <div className={maintenanceStyles.several_questions_grid_3}>
                    <QuestionInput question="Mi nombre es" _onChange={handleInputChange} inputs={inputs} placeholder="Miguel Angel" name="nombre" required={true} error={errors.nombre} />
                    <QuestionInput question="y apellidos" _onChange={handleInputChange} inputs={inputs} placeholder="Medina Calvillo" name="apellidos" required={true} error={errors.apellidos} />
                    <QuestionInput question="Vivo en la calle" _onChange={handleInputChange} inputs={inputs} placeholder="Miguel Hidalgo" name="calle" required={true} error={errors.calle} />
                  </div>
                  <div className={maintenanceStyles.several_questions_grid_3}>
                    <QuestionInput question="número exterior" _onChange={handleInputChange} inputs={inputs} placeholder="1534" name="num_ext" required={true} error={errors.num_ext} />
                    <QuestionInput question="y número interior" _onChange={handleInputChange} inputs={inputs} placeholder="15" name="num_int" error={errors.num_int} />
                    <QuestionInput question="en la colonia" _onChange={handleInputChange} inputs={inputs} placeholder="Independencia" name="colonia" required={true} error={errors.colonia} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow_nopadding} question="ubicada en la ciudad de" _onChange={handleInputChange} inputs={inputs} placeholder="Saltillo" name="ciudad" required={true} error={errors.ciudad} />
                    <QuestionInput _classContainer={maintenanceStyles.input__padding} question="del estado de" _onChange={handleInputChange} inputs={inputs} placeholder="Coahuila" name="estado" required={true} error={errors.estado} />
                    <QuestionInput _classContainer={maintenanceStyles.input__padding} question="con C.P." _onChange={handleInputChange} inputs={inputs} placeholder="25000" name="codigo_postal" required={true} error={errors.codigo_postal} />
                  </div>
                  <div className={`${maintenanceStyles.several_questions_flex} ${maintenanceStyles.no__margin_bottom}`}>
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow_nopadding} question="Para comunicarse conmigo, escribir al correo" _onChange={handleInputChange} inputs={inputs} placeholder="miguel_medina@correo.com" name="email" required={true} type="email" error={errors.email} />
                    <QuestionInput _classContainer={maintenanceStyles.input__padding} question="o llamar el número" _onChange={handleInputChange} inputs={inputs} placeholder="844 63 87 033" name="phone" required={true} error={errors.phone} maxlength="10" />
                  </div>
                </div>
              </>
            )
          case "xlg":
            return (
              <>
                <div className={maintenanceStyles.step1__container}>
                  <div className={maintenanceStyles.several_questions_grid_3}>
                    <QuestionInput question="Mi nombre es" _onChange={handleInputChange} inputs={inputs} placeholder="Miguel Angel" name="nombre" required={true} error={errors.nombre} />
                    <QuestionInput question="y apellidos" _onChange={handleInputChange} inputs={inputs} placeholder="Medina Calvillo" name="apellidos" required={true} error={errors.apellidos} />
                    <QuestionInput question="Vivo en la calle" _onChange={handleInputChange} inputs={inputs} placeholder="Miguel Hidalgo" name="calle" required={true} error={errors.calle} />
                  </div>
                  <div className={maintenanceStyles.several_questions_grid_3}>
                    <QuestionInput question="número exterior" _onChange={handleInputChange} inputs={inputs} placeholder="1534" name="num_ext" required={true} error={errors.num_ext} />
                    <QuestionInput question="y número interior" _onChange={handleInputChange} inputs={inputs} placeholder="15" name="num_int" error={errors.num_int} />
                    <QuestionInput question="en la colonia" _onChange={handleInputChange} inputs={inputs} placeholder="Independencia" name="colonia" required={true} error={errors.colonia} />
                  </div>
                  <div className={maintenanceStyles.several_questions_flex}>
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow_nopadding} question="ubicada en la ciudad de" _onChange={handleInputChange} inputs={inputs} placeholder="Saltillo" name="ciudad" required={true} error={errors.ciudad} />
                    <QuestionInput _classContainer={maintenanceStyles.input__padding} question="del estado de" _onChange={handleInputChange} inputs={inputs} placeholder="Coahuila" name="estado" required={true} error={errors.estado} />
                    <QuestionInput _classContainer={maintenanceStyles.input__padding} question="con C.P." _onChange={handleInputChange} inputs={inputs} placeholder="25000" name="codigo_postal" required={true} error={errors.codigo_postal} />
                  </div>
                  <div className={`${maintenanceStyles.several_questions_flex} ${maintenanceStyles.no__margin_bottom}`}>
                    <QuestionInput _classContainer={maintenanceStyles.flex__grow_nopadding} question="Para comunicarse conmigo, escribir al correo" _onChange={handleInputChange} inputs={inputs} placeholder="miguel_medina@correo.com" name="email" required={true} type="email" error={errors.email} />
                    <QuestionInput _classContainer={maintenanceStyles.input__padding} question="o llamar el número" _onChange={handleInputChange} inputs={inputs} placeholder="844 63 87 033" name="phone" required={true} error={errors.phone} maxlength="10" />
                  </div>
                </div>
              </>
            )
          default:
            return null
        }
      default:
        return null
    }
  }

  function getNextButton() {
    switch (step) {
      case 0:
        return (
          <div className={maintenanceStyles.next__button_container}>
            <ButtonSemicircle _onClick={handleNextStep} _text="Comenzar" _className={maintenanceStyles.next__button} />
          </div>
        )

      case 1:
        return (
          <div className={maintenanceStyles.next__button_container}>
            <ButtonArrow _classIcon="icon_maintenance" _section="maintenance" _textClass={maintenanceStyles.back__button_text} _className={`${maintenanceStyles.back__button_tablet} ${maintenanceStyles.back__button_desktop}`} _text="Volver" _onClick={handleBackStep} _position={POSITION.BEFORE} _type={TYPES.PREV} />
            {/*Object.keys(errors).length !== 0 ? <p className={maintenanceStyles.required__message}>*Por favor, rellena estos campos para continuar.</p> : null*/}
            <ButtonSemicircle _onClick={handleNextStep} _text="Continuar" _className={maintenanceStyles.next__button} />
          </div>
        )
      case 2:
        return (
          <div className={maintenanceStyles.next__button_container}>
            <ButtonArrow _classIcon="icon_maintenance" _section="maintenance" _textClass={maintenanceStyles.back__button_text} _className={`${maintenanceStyles.back__button_tablet} ${maintenanceStyles.back__button_desktop}`} _text="Anterior" _onClick={handleBackStep} _position={POSITION.BEFORE} _type={TYPES.PREV} />
            {/*Object.keys(errors).length !== 0 ? <p className={maintenanceStyles.required__message}>*Por favor, rellena estos campos para continuar.</p> : null*/}
            <ButtonSemicircle _onClick={handlerClickSend} _text="Enviar" _className={disabled ? maintenanceStyles.next__button_disable : maintenanceStyles.next__button} />
          </div>
        )
      default:
        break
    }
  }

  return (
    <Layout>
      <div className={maintenanceStyles.maintenance__container}>
        {versions && step === 0 ? (
          <>
            <MaintenanceTitle getStepText={getStepText} step={step} title_text="Solicita ayuda" />
            <div className={maintenanceStyles.step0__container}>{getQuestions()}</div>
            {getNextButton()}
          </>
        ) : (
          <>
            <ButtonArrow _textClass={maintenanceStyles.back__button_text} _className={`${maintenanceStyles.back__button} ${maintenanceStyles.back__button_mobile}`} _text="Volver" _onClick={handleBackStep} _position={POSITION.BEFORE} _type={TYPES.PREV} />
            <MaintenanceTitle getStepText={getStepText} step={step} title_text="Solicita ayuda" />
            <div className={maintenanceStyles.form__container}>
              <form noValidate id="maintenance__form" className={maintenanceStyles.maintenance__form} method="post" action="/enviado" onSubmit={handleSubmit}>
                {getQuestions()}
                <button id="submit__button" type="submit" className={maintenanceStyles.submit__button} />
              </form>
            </div>
            {getNextButton()}
          </>
        )}
      </div>
    </Layout>
  )
}

export default Maintenance
